<div class="checkbox absolute">
    <mat-checkbox
        *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_CABIN_USE"
        [checked]="sectionVisibility.showCabine"
        (change)="toggleSectionVisibility('showCabine')">{{wording.cabin}}</mat-checkbox>
    <mat-checkbox
        *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_MAXVIAS_USE"
        [checked]="sectionVisibility.showVia"
        (change)="toggleSectionVisibility('showVia')">{{wording.maxVias}}</mat-checkbox>
    <mat-checkbox
            *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_TIME_SLOTS_USE"
            [checked]="sectionVisibility.showTimeSlots"
            (change)="toggleSectionVisibility('showTimeSlots')">{{wording.timeSlots}}</mat-checkbox>
</div>
<div *ngFor="let segment of airSegmentSearchForm.controls; let i = index" [formGroup]="segment" class="segment">
    <div class="itinerary flex-column">
        <h2 class="form-title"><span [style.visibility]="i===0 ? 'visible' : 'hidden'">{{ wording.multiple }}</span></h2>
        <div class="flex-row">
            <div class="buttons">
                <btnForm styleType="actionLink"
                    *ngIf="airSegmentSearchForm.controls.length > 1"
                    (click)="removeField(i)">
                    <fa-icon [icon]="iconMinus"></fa-icon>
                </btnForm>
                <btnForm styleType="actionLink"
                    *ngIf="i === (airSegmentSearchForm.controls.length-1)"
                    (click)="addSegmentGroup()">
                    <fa-icon [icon]="iconPlus"></fa-icon>
                </btnForm>
            </div>
            <airport-select
                [tabindex]="0"
                [direction]="eSegmentFields.from"
                [firstLocationCode]="airSegmentSearchForm.get([i, eSegmentFields.from]).value"
                [firstIsAirportOnly]="airSegmentSearchForm.get([i, eSegmentFields.isFromAirport]).value"
                (onChooseLocation)="patchSegment($event, eSegmentFields.from, i); prefillFromToFields('add')"
            ></airport-select>
            <airport-select
                [tabindex]="1"
                [direction]="eSegmentFields.to"
                [firstLocationCode]="airSegmentSearchForm.get([i, eSegmentFields.to]).value"
                [firstIsAirportOnly]="airSegmentSearchForm.get([i, eSegmentFields.isToAirport]).value"
                (onChooseLocation)="patchSegment($event, eSegmentFields.to, i); prefillFromToFields('add')"
            ></airport-select>
            <date-field
                [onlyOneMonth]="onlyOneMonth"
                [fieldConfig]="{
                    formGroup: segment.get(eSegmentFields.begin),
                    formControlName: eSegmentFields.value,
                    minDate:getLastDate(i),
                    defaultDate:getLastDate(i),
                    placeholder: wording.date,
                    validators: dateValidator}"
            ></date-field>
        </div>
    </div>
    <div class="fields">
        <ng-container *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_CABIN_USE">
            <div *ngIf="sectionVisibility.showCabine" class="field cabin flex-column">
                <h2 class="form-title">{{ wording.cabin }}</h2>
                <div class="flex-row">
                    <combobox-field
                        [items]="cabinItems"
                        (onOptionSelection)="onSelectCabin($event,i)"
                        [fieldConfig]="{
                            formGroup: segment,
                            formControlName: eSegmentFields.cabin,
                            placeholder: wording.viaCabinPlaceholder}"
                    ></combobox-field>
                </div>
            </div>
        </ng-container>
        <ng-container *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_MAXVIAS_USE">
            <div *ngIf="sectionVisibility.showVia" class="field maxvias flex-column">
                <h2 class="form-title">{{ wording.maxVias }}</h2>
                <div class="flex-row">
                    <combobox-field
                        [items]="maxViasItems"
                        [fieldConfig]="{
                            formGroup: segment,
                            formControlName: eSegmentFields.maxVias,
                            placeholder: wording.viaCabinPlaceholder}"
                    ></combobox-field>
                    <number
                        class="number-input"
                        [showPlusAndMinus]="false"
                        [align]="'center'"
                        [isFull]="true"
                        [fieldConfig]="{
                            min: 0,
                            fixed: 0,
                            placeholder: wording.maxDuration,
                            formGroup: segment.get(eSegmentFields.duration),
                            formControlName: eSegmentFields.max,
                            iconDefinition: iconHourglass}"
                    ></number>
                    <combobox-field
                        [items]="viaDurationUnitItems"
                        [fieldConfig]="{
                            formGroup: segment.get(eSegmentFields.duration),
                            formControlName: eSegmentFields.unit,
                            placeholder: wording.viaDurationUnitPlaceholder}"
                    ></combobox-field>
                </div>
            </div>
        </ng-container>
        <ng-container *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_TIME_SLOTS_USE">
            <div *ngIf="sectionVisibility.showTimeSlots" class="field timeSlots flex-column">
                <h2 class="form-title">{{ wording.timeSlots }}</h2>
                <div class="flex-row">
                    <ng-container [formGroup]="segment.get(eSegmentFields.begin).get(eSegmentFields.between).get(eSegmentFields.min)">
                        <!-- TO BE USED LATER
                        <input class="min-begin-time" type="time"
                               [formControlName]="eSegmentFields.time"
                               [max]="getMaxBeginHour(i)">
                        <p-calendar
                                [timeOnly]="true"
                                hourFormat="24"
                                [maxDate]="getMaxBeginHour(i)"
                                [placeholder]="wording.minBedinTime"
                                [formControlName]="eSegmentFields.time">
                        </p-calendar>-->
                        <input class="min-begin-time" type="text"
                               [formControlName]="eSegmentFields.time"
                               [placeholder]="wording.minBedinTime"
                               onfocus="(this.type='time')"
                               onblur="(this.type='text')">
                    </ng-container>
                    <ng-container [formGroup]="segment.get(eSegmentFields.begin).get(eSegmentFields.between).get(eSegmentFields.max)">
                        <input class="max-begin-time" type="text"
                               [formControlName]="eSegmentFields.time"
                               [placeholder]="wording.maxBeginTime"
                               onfocus="(this.type='time')"
                               onblur="(this.type='text')">
                        <!-- <p-calendar
                                [timeOnly]="true"
                                hourFormat="24"
                                [minDate]="getMinBeginHour(i)"
                                [placeholder]="wording.minBedinTime"
                                [formControlName]="eSegmentFields.time">
                        </p-calendar>
                        <mat-form-field>
                            <input type="time" matInput [min]="getMinBeginHour(i)"  [formControlName]="eSegmentFields.time" />
                        </mat-form-field>
                        -->
                    </ng-container>
                    <ng-container [formGroup]="segment.get(eSegmentFields.end).get(eSegmentFields.between).get(eSegmentFields.max)">
                        <input class="min-end-time" type="text"
                               [formControlName]="eSegmentFields.time"
                               [placeholder]="wording.minEndTime"
                               onfocus="(this.type='time')"
                               onblur="(this.type='text')">
                    </ng-container>
                    <ng-container [formGroup]="segment.get(eSegmentFields.end)">
                        <mat-checkbox *ngIf="showNightFlight"
                                      [checked]="checkedNightFlight[i]"
                                      (change)="toggleNightFlight(i)"
                                      [formControlName]="eSegmentFields.xMoment">{{wording.nightFlight}}</mat-checkbox>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>



